module.exports = __webpack_public_path__ + "img/logo_hd.ac60868.webp";